import React, { useState } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Modal, Header, Close, Footer } from "MODULES/shared/components/Modal";
import api from "APP_ROOT/api";
import CommercialInvoiceForm from "MODULES/shared/components/CommercialInvoice/Form";
import LineItemsForm from "MODULES/shared/components/CommercialInvoice/Form/FormSections/LineItemsForm";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import {
  COUNTRY_OF_MFG,
  DESCRIPTION,
  EUROPEAN_COMMERCE_CONTROL_NUMBER,
  PART_NUMBER
} from "MODULES/parts/constants";
import { countryCode } from "LIB/countries";
import pojo from "../../../../lib/pojos";

export default function CreateCommercialInvoice({ editing, close, inventory }) {
  const [lineItemsForm, setLineItemsForm] = useState(false);
  const [commercialInvoiceForm, setCommercialInvoiceForm] = useState(false);
  const [lineItems, setLineItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getLineItems = () => {
    setIsLoading(true);
    const inv = inventory.toJS();

    api.inventories
      .search({
        store_location_id: inv.store_location_id,
        transfer_to_location_id: inv.transfer_to_location_id,
        limit: 100
      })
      .then(resp => {
        const results = resp.data.results;
        if (results.length > 1) {
          setLineItems(results);
          setLineItemsForm(true);
        } else {
          setLineItems(results);
          setCommercialInvoiceForm(true);
        }
        setIsLoading(false);
      });
  };

  const addLineItems = selectedLineItems => {
    setLineItems([...selectedLineItems]);
    setCommercialInvoiceForm(true);
  };

  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Create Commercial Invoice</h4>
      </Header>
      {commercialInvoiceForm && (
        <CommercialInvoiceForm
          close={close}
          initialValues={initialValues(inventory.toJS(), lineItems)}
          selectedLineItems={lineItems}
          hazmat={inventory.getIn(["part", "hazmat"])}
          enableReinitialize
        />
      )}
      {lineItemsForm &&
        !commercialInvoiceForm && (
          <LineItemsForm
            close={close}
            addLineItems={addLineItems}
            lineItems={lineItems}
            enableReinitialize
          />
        )}
      {!commercialInvoiceForm &&
        !lineItemsForm && (
          <Footer>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => close()}
            >
              Cancel
            </button>{" "}
            <button
              type="button"
              className="btn btn-success"
              onClick={getLineItems}
            >
              {isLoading ? "...Loading" : "Yes"}
            </button>
          </Footer>
        )}
    </Modal>
  );
}

CreateCommercialInvoice.propTypes = {
  inventory: PropTypes.shape({}).isRequired,
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};

function getEin(item) {
  const location = useCurrentUser().locations.find(
    l => l.id === item.store_location_id
  );
  if (location) {
    return location.tax_id_number;
  }

  return "";
}

function getAddress(item) {
  const location = useCurrentUser().locations.find(
    l => l.id === item.store_location_id
  );

  if (location) {
    const { line1, line2, city, state, country, phone, postal_code } = location;

    return {
      company_name: location.entity_name,
      line1,
      line2,
      city,
      state,
      country: countryCode(country),
      phone,
      postal_code
    };
  }

  return null;
}

function initialValues(inventory, lineItems) {
  return {
    cargo_screening_consent: true,
    inventory_id: get(inventory, "id"),
    ein: getEin(inventory),
    hazmat: lineItems.some(i => get(i, "part.hazmat")),
    ultimate_consignee_address: getAddress(inventory),
    weight_unit: "lb",
    line_items:
      lineItems &&
      lineItems.map(item => ({
        condition: item.condition,
        inventory_id: item.id,
        part_id: item.part.id,
        price: item.cost_per_unit,
        quantity: item.quantity,
        serial_number: item.serial_number,
        weight_unit: item.part.net_weight_unit || "lb",
        weight: item.part.net_weight,
        weight_oz: item.part.net_weight_oz,
        ...pojo(item.part).pick(
          COUNTRY_OF_MFG,
          DESCRIPTION,
          PART_NUMBER,
          EUROPEAN_COMMERCE_CONTROL_NUMBER
        )
      }))
  };
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/CreateCommercialInvoice.jsx